<template>
  <div>
    <autoLogout />
    <loader :loader="loader || sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="text-center pb-4">
            <branch-offices-list
              v-on:triggerChange="branchOfficeSelected"
              style="padding-left: 10px"
              :model="idBranchOfficeSelected"
            />

            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" xl="2" sm="12">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    color="primary"
                    @click="$router.push('/usuarios/nuevoUsuario')"
                    v-if="$utilFront.withPermission($prm.ADD_USER)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left> mdi-account-plus </v-icon>
                    Nuevo usuario
                  </v-btn>
                </template>
                <span>Agregar nuevo usuario</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="listUsers"
            :search="search"
            :items-per-page="10"
            :icono="icono"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
            }"
            no-results-text="Sin resultados coincidentes con la búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
          >
            <template v-slot:[`item.status`]="{ item }">
              <v-tooltip
                top
                v-if="$utilFront.withPermission($prm.UPDATE_STATUS_USER)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    @click.native.prevent.stop.capture="ask($event, item)"
                  >
                    <v-switch
                      v-bind="attrs"
                      v-on="on"
                      name="switch"
                      v-model="item.status"
                      color="success"
                    ></v-switch>
                  </v-btn>
                </template>
                <span>Eliminar paciente</span>
              </v-tooltip>
              <span
                v-else
                :class="{
                  'error--text': !item.status,
                  'success--text': item.status,
                }"
              >
                {{ item.status ? "Activo" : "Inactivo" }}
              </span>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    @click="getUserInformation(item, 'GET_INFORMATION')"
                  >
                    <v-icon color="secondary" v-bind="attrs" v-on="on">
                      {{ icono.icon }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ icono.tooltip }}</span>
              </v-tooltip>

              <v-menu
                offset-y
                :nudge-width="200"
                :close-on-content-click="true"
                v-if="
                  $utilFront.withPermission($prm.UPDATE_USER) ||
                    $utilFront.withPermission($prm.RESET_PASSWORD_USER)
                "
              >
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <span>Más opciones</span>
                  </v-tooltip>
                </template>

                <v-list dense>
                  <v-list-item
                    link
                    @click="getUserInformation(item, 'UPDATE_INFORMATION')"
                    v-if="$utilFront.withPermission($prm.UPDATE_USER)"
                  >
                    <v-list-item-icon>
                      <v-icon color="warning"> mdi-pencil </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Editar usuario</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    link
                    v-if="$utilFront.withPermission($prm.RESET_PASSWORD_USER)"
                    @click="resPassword(item)"
                  >
                    <v-list-item-icon>
                      <v-icon color="yellow"> mdi-restart </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        Restablecer contraseña
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- USER DETAILS -->
      <encabezado
        :elementos="titleUsers"
        v-if="showAction(2) || showAction(3)"
      />
      <v-card v-if="showAction(2) || showAction(3)">
        <validation-observer ref="formUpdateInfo" v-slot="{ invalid }">
          <v-form lazy-validation v-model="valid">
            <v-card-text>
              <v-container>
                <!-- Informacion personal -->
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black">Información personal</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Nombre"
                      rules="required|max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$"
                    >
                      <v-text-field
                        v-model.trim="userInfo.name"
                        label="Nombre(s)"
                        prepend-icon="mdi-account"
                        required
                        :counter="60"
                        :maxlength="60"
                        :error-messages="errors"
                        :disabled="isEditing"
                        @input="capitalize"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Primer apellido"
                      rules="required|max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$"
                    >
                      <v-text-field
                        v-model.trim="userInfo.firstLastname"
                        label="Primer apellido"
                        prepend-icon="mdi-account"
                        required
                        :counter="60"
                        :maxlength="60"
                        :error-messages="errors"
                        :disabled="isEditing"
                        @input="capitalize"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Segundo apellido"
                      rules="max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$"
                    >
                      <v-text-field
                        v-model.trim="userInfo.secondLastname"
                        label="Segundo apellido"
                        prepend-icon="mdi-account"
                        required
                        :counter="60"
                        :maxlength="60"
                        :error-messages="errors"
                        :disabled="isEditing"
                        @input="capitalize"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="CURP"
                      rules="requiredCurp|curp"
                    >
                      <v-text-field
                        v-model="userInfo.curp"
                        label="CURP"
                        prepend-icon="mdi-card-account-details"
                        required
                        :counter="18"
                        :maxlength="18"
                        :error-messages="errors"
                        :disabled="isEditing"
                        @input="
                          (val) => (userInfo.curp = userInfo.curp.toUpperCase())
                        "
                      ></v-text-field>
                    </validation-provider>
                    <p class="caption text--secondary">
                      Si desconoce la CURP utiliza el formato XXXX999999XXXXXX99
                    </p>
                  </v-col>
                   <v-col cols="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="RFC"
                      rules="max:13|min:12"
                    >
                      <v-text-field
                        v-model.trim="userInfo.rfc"
                        label="RFC"
                        prepend-icon="mdi-account-file-text-outline"
                        :counter="13"
                        :maxlength="13"
                        :error-messages="errors"
                        :disabled="isEditing"
                        @input="(val) => (userInfo.rfc = userInfo.rfc.toUpperCase())"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Sexo"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="userInfo.gender"
                        label="Sexo"
                        prepend-icon="mdi-gender-male-female"
                        no-data-text="Sin resultados disponibles"
                        required
                        :error-messages="errors"
                        :disabled="isEditing"
                        :items="genero"
                        :item-value="genero.value"
                        :item-text="genero.text"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <!-- <vc-date-picker
                            :max-date="new Date()"
                            color="green"
                            v-model="date"
                          > -->
                    <!-- <template v-slot="{ inputEvents, inputValue }"> -->
                    <v-text-field
                      type="date"
                      v-model="date"
                      :max="new Date().toISOString().split('T')[0]"
                      label="Fecha de nacimiento*"
                      :rules="nameRules"
                      hint="Formato DD/MM/YYYY"
                      :disabled="isEditing"
                      required
                    ></v-text-field>
                    <!-- </template> -->
                    <!-- </vc-date-picker> -->
                  </v-col>
                  <!-- <v-col cols="4">
                    <v-menu
                      v-model="dateBirthdate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      :close-on-content-click="false"
                      :nudge-right="40"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <validation-provider
                          v-slot="{ errors }"
                          name="Fecha de nacimiento"
                          rules="required"
                        >
                          <v-text-field
                            id="fechaNac"
                            v-model="dateFormatted"
                            label="Fecha de nacimiento"
                            prepend-icon="mdi-calendar"
                            hint="Formato DD/MM/YYYY"
                            v-bind="attrs"
                            v-on="on"
                            required
                            :disabled="isEditing"
                            :error-messages="errors"
                            @blur="date = parseDate(dateFormatted)"
                          ></v-text-field>
                        </validation-provider>
                      </template>
                      <v-date-picker
                        :max-date="new Date()"
                        v-model="date"
                        min="1920-01-01"
                        locale="es"
                        :active-picker.sync="activePicker"
                        @input="dateBirthdate = false"
                      ></v-date-picker>
                    </v-menu>
                     <v-text-field
                  v-model="userInfo.birthDate"
                  label="Fecha de nacimiento"
                  prepend-icon="mdi-calendar"
                  :disabled="isEditing"
                >
                </v-text-field> 
                  </v-col> -->
                </v-row>
                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Nacionalidad"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="userInfo.nationality"
                        label="Nacionalidad"
                        prepend-icon="mdi-flag-variant-outline"
                        no-data-text="Sin resultados disponibles"
                        :error-messages="errors"
                        :disabled="isEditing"
                        :items="nationality"
                        :item-text="nationality.text"
                        :item-value="nationality.value"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <template
                    v-if="
                      userInfo.nationality && userInfo.nationality === 'Otro'
                    "
                  >
                    <v-col cols="12" md="3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Nacionalidad"
                        rules="required|regex:^[a-zA-ZÀ-ÿ ]+$|max:80"
                      >
                        <v-text-field
                          v-model="otherNationality"
                          label="Nacionalidad"
                          prepend-icon="mdi-flag-variant"
                          :counter="80"
                          :maxlength="80"
                          :error-messages="errors"
                          :disabled="isEditing"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </template>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Entidad federativa"
                      rules="required"
                    >
                      <v-autocomplete
                        prepend-icon="fas fa-map-pin"
                        v-model="userInfo.birthFederalEntity"
                        label="Entidad federativa de nacimiento*"
                        :error-messages="errors"
                        :items="birthFederalEntities"
                        :item-text="birthFederalEntities.text"
                        :item-value="birthFederalEntities.value"
                        :disabled="isEditing"
                        required
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Estado civil"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="userInfo.maritalStatus"
                        label="Estado civil"
                        prepend-icon="mdi-account-heart"
                        required
                        :error-messages="errors"
                        :disabled="isEditing"
                        :items="estadoCivil"
                        :item-value="estadoCivil.value"
                        :item-text="estadoCivil.text"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- ----------------------------- -->

                <!-- Informacion de contacto -->
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black">Información de contacto</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="8" lg="8" sm="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Dirección"
                      rules="required|max:100"
                    >
                      <v-text-field
                        v-model.trim="userInfo.street"
                        label="Direccion"
                        prepend-icon="fas fa-road"
                        required
                        :counter="100"
                        :maxLength="100"
                        :error-messages="errors"
                        :disabled="isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Número exterior"
                      rules="required|max:5"
                    >
                      <v-text-field
                        v-model.trim="userInfo.outdoorNumber"
                        label="Número exterior"
                        prepend-icon="mdi-pound"
                        required
                        :counter="5"
                        :maxLength="5"
                        :error-messages="errors"
                        :disabled="isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Número interior"
                      rules="max:5"
                    >
                      <v-text-field
                        v-model.trim="userInfo.interiorNumber"
                        label="Número interior"
                        prepend-icon="mdi-pound-box-outline"
                        :counter="5"
                        :maxLength="5"
                        :error-messages="errors"
                        :disabled="isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Código postal"
                      rules="required|max:5|numeric"
                    >
                      <v-text-field
                        v-model.trim="userInfo.postalCode"
                        label="Código postal"
                        prepend-icon="mdi-mailbox-outline"
                        required
                        :maxLength="5"
                        :error-messages="errors"
                        :disabled="isEditing"
                        :counter="5"
                        @change="findAddress"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col v-if="!noPostal">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Entidad federativa"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="userInfo.federalEntity"
                        label="Entidad federativa"
                        prepend-icon="mdi-map-marker-radius"
                        no-data-text="Sin resultados disponibles"
                        required
                        :error-messages="errors"
                        :disabled="isEditing"
                        :items="federalEntities"
                        :item-text="federalEntities.text"
                        :item-value="federalEntities.value"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col v-if="!noPostal">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Municipio"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="userInfo.municipalityEntity"
                        label="Municipio"
                        prepend-icon="mdi-map-outline"
                        no-data-text="Sin resultados disponibles"
                        required
                        :error-messages="errors"
                        :disabled="isEditing"
                        :items="municipalities"
                        :item-text="municipalities.text"
                        :item-value="municipalities.value"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col v-if="!noPostal">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Colonia"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="userInfo.colonyKey"
                        label="Colonia"
                        prepend-icon="mdi-map-marker"
                        no-data-text="Sin resultados disponibles"
                        :error-messages="errors"
                        :disabled="isEditing"
                        :items="colonies"
                        :item-text="colonies.text"
                        :item-value="colonies.value"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>

                  <v-col v-if="noPostal">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Entidad federativa"
                      rules="required"
                    >
                      <v-text-field
                        v-model="userInfo.federalEntity"
                        label="Entidad federativa"
                        prepend-icon="mdi-map-marker-radius"
                        required
                        :disabled="isEditing"
                        :error-messages="errors"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col v-if="noPostal">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Municipio"
                      rules="required"
                    >
                      <v-text-field
                        v-model="userInfo.municipalityEntity"
                        label="Municipio"
                        prepend-icon="mdi-map-outline"
                        required
                        :disabled="isEditing"
                        :error-messages="errors"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col v-if="noPostal">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Colonia"
                      rules="required"
                    >
                      <v-text-field
                        v-model="userInfo.colonyKey"
                        label="Colonia"
                        prepend-icon="mdi-map-marker"
                        required
                        :disabled="isEditing"
                        :error-messages="errors"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Correo electrónico"
                      rules="required|max:50|email"
                    >
                      <v-text-field
                        v-model.trim="userInfo.email"
                        label="Correo electrónico"
                        prepend-icon="mdi-at"
                        required
                        :counter="50"
                        :maxLength="50"
                        :error-messages="errors"
                        :disabled="isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Teléfono móvil"
                      rules="required|max:10"
                    >
                      <v-text-field
                        v-model.trim="userInfo.cellphone"
                        label="Teléfono móvil"
                        prepend-icon="mdi-cellphone"
                        :counter="10"
                        :maxLength="10"
                        :error-messages="errors"
                        :disabled="isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Télefono fijo"
                      rules="max:10"
                    >
                      <v-text-field
                        v-model.trim="userInfo.homePhone"
                        label="Teléfono fijo"
                        prepend-icon="mdi-phone"
                        :counter="10"
                        :maxLength="10"
                        :error-messages="errors"
                        :disabled="isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- ----------------------------- -->

                <!-- Información de empleado -->
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black">Información laboral</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Nombre de usuario"
                      rules="required|max:50"
                    >
                      <v-text-field
                        v-model.trim="userInfo.userName"
                        label="Nombre de usuario"
                        prepend-icon="mdi-badge-account"
                        required
                        :error-messages="errors"
                        :maxLength="50"
                        :counter="50"
                        :disabled="isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Rol"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="userInfo.role"
                        label="Rol"
                        prepend-icon="mdi-account-convert"
                        no-data-text="Sin resultados disponibles"
                        required
                        :error-messages="errors"
                        :disabled="isEditing"
                        :items="roles"
                        :item-value="roles.value"
                        :item-text="roles.text"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Tipo de personal"
                      rules="required|max:50"
                    >
                      <v-autocomplete
                        v-model="userInfo.personalType"
                        label="Tipo de personal"
                        prepend-icon="mdi-account-supervisor"
                        no-data-text="Sin resultados disponibles"
                        required
                        :error-messages="errors"
                        :disabled="isEditing"
                        :items="personalType"
                        :item-value="personalType.value"
                        :item-text="personalType.text"
                      ></v-autocomplete>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Clave del personal"
                      rules="required|max:20"
                    >
                      <v-text-field
                        v-model.trim="userInfo.humanResourceKey"
                        label="Clave del personal"
                        prepend-icon="mdi-account-key"
                        required
                        :counter="20"
                        :maxLength="20"
                        :error-messages="errors"
                        :disabled="isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Sucursales asignadas"
                    >
                      <v-autocomplete
                        v-model="userInfo.branchOfficeList"
                        label="Sucursales asignadas"
                        prepend-icon="mdi-office-building-cog"
                        no-data-text="Sin resultados disponibles"
                        multiple
                        small-chips
                        :error-messages="errors"
                        :readonly="isEditing"
                        :items="assignBranches"
                        :item-value="assignBranches.value"
                        :item-text="assignBranches.text"
                      >
                        <template
                          v-slot:selection="{ attr, on, item, selected }"
                        >
                          <v-chip
                            v-bind="attr"
                            :input-value="selected"
                            color="primary"
                            v-on="on"
                          >
                            <span v-text="item.text"></span>
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Modalidades asignadas"
                    >
                      <v-autocomplete
                        v-model="userInfo.modalitiesList"
                        label="Modalidades asignadas"
                        prepend-icon="mdi-clipboard-check"
                        no-data-text="Sin resultados disponibles"
                        multiple
                        small-chips
                        :error-messages="errors"
                        :items="modalitiesList"
                        :item-text="modalitiesList.text"
                        :item-value="modalitiesList.value"
                        :readonly="isEditing"
                      >
                        <template
                          v-slot:selection="{ attr, on, item, selected }"
                        >
                          <v-chip
                            v-bind="attr"
                            :input-value="selected"
                            color="primary"
                            v-on="on"
                          >
                            <span v-text="item.text"></span>
                          </v-chip>
                        </template>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Id externo"
                      rules="required|max:10"
                    >
                      <v-text-field
                        v-model.trim="userInfo.externalId"
                        :maxlength="20"
                        label="Id externo*"
                        required
                        :disabled="isEditing"
                        :error-messages="errors"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>

                <!-- ----------------------------- -->

                <!-- Información profesional -->
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black">Información profesional</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Institución/Universidad de egreso"
                      rules="max:100|required"
                    >
                      <v-text-field
                        v-model.trim="userInfo.studyDegree"
                        label="Institución/Universidad de egreso"
                        prepend-icon="mdi-account-school"
                        :counter="100"
                        :maxLength="100"
                        :error-messages="errors"
                        :disabled="isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Título académico"
                      rules="max:100"
                    >
                      <v-text-field
                        v-model.trim="userInfo.academicTitle"
                        label="Título académico"
                        prepend-icon="mdi-school"
                        :counter="100"
                        :maxLength="100"
                        :error-messages="errors"
                        :disabled="isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Acrónimo"
                      rules="max:10"
                    >
                      <v-text-field
                        v-model.trim="userInfo.acronym"
                        label="Acrónimo"
                        prepend-icon="mdi-alphabetical-variant"
                        :counter="10"
                        :maxLength="10"
                        :error-messages="errors"
                        :disabled="isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Número de licencia"
                      rules="max:50"
                    >
                      <v-text-field
                        v-model.trim="userInfo.professionalLicense"
                        label="Número de licencia o cédula profesional"
                        prepend-icon="mdi-school-outline"
                        :counter="50"
                        :maxLength="50"
                        :error-messages="errors"
                        :disabled="isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- ----------------------------- -->

                <!-- Firma -->
                <v-row>
                  <v-col>
                    <h3 class="font-weight-black">Firma</h3>
                  </v-col>
                </v-row>

                <v-row v-if="userInfo.sign == null">
                  <v-col>
                    <p class="font-weight-black title error--text text-center">
                      El usuario no cuenta con firma
                    </p>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" v-if="action == 3">
                  <v-col cols="12" md="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Firma"
                      :rules="
                        `${
                          requiredSign == true || validTypePerson == true
                            ? 'required'
                            : ''
                        }`
                      "
                    >
                      <v-file-input
                        v-model="filesSign"
                        label="Agregar firma"
                        prepend-icon="mdi-pen"
                        ref="uploadFile"
                        accept="image/png, image/jpeg, image/jpg"
                        truncate-length="15"
                        dense
                        :required="requiredSign || validTypePerson"
                        :error-messages="errors"
                        @change="validateSign"
                        @click:append="validateSign"
                      ></v-file-input>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  justify="center"
                  v-if="userInfo.sign != null"
                >
                  <v-img
                    position="center center"
                    max-width="300"
                    :src="'data:image/*;base64,' + userInfo.sign"
                  ></v-img>
                </v-row>

                <!-- ----------------------------- -->
              </v-container>
            </v-card-text>
            <v-card-actions class="text-center">
              <v-col>
                <v-btn plain color="error" @click="changeAction(1)">
                  <v-icon left>mdi-chevron-left</v-icon> Volver
                </v-btn>
              </v-col>
              <v-col v-if="updateInfo">
                <v-btn
                  color="primary"
                  @click="saveSignToUser"
                  :disabled="invalid || sending || loader"
                  :loading="sending"
                >
                  Guardar informacion <v-icon right>mdi-content-save</v-icon>
                  <template v-slot:loader>
                    <span>Guardando informacion...</span>
                  </template>
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>
      <!-- ----------------------------- -->
    </div>

    <v-dialog v-model="dialogDelete" persistent max-width="450">
      <v-card>
        <v-card-title class="text-h6 text-center"> Advertencia </v-card-title>
        <v-card-text
          >¿Desea {{ objDelete.status == 1 ? "desactivar" : "activar" }} el
          registro del usuario:
          <span class="font-weight-black"
            >{{ objDelete.nameUser }} ({{ objDelete.idUser }})</span
          >?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogDelete = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :disabled="sending"
            text
            @click="changeStatus()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRestore" persistent max-width="450">
      <v-card>
        <v-card-title class="text-h6 text-center"> Advertencia </v-card-title>
        <v-card-text
          >La constraseña se modificará a
          <span class="font-weight-black">{{ objRestore.email }}</span> ¿Desea
          restablece la contraseña para:
          <span class="font-weight-black"
            >{{ objRestore.nameUser }} ({{ objRestore.idUser }})</span
          >?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogRestore = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="resPassword(objRestore)"
            :disabled="loader"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  UserRequest,
  EnumRequest,
  RoleRequest,
  PersonalTypeRequest,
  BranchOfficeRequest,
  SepomexRequest,
  ModaltyRequest,
  FederalEntityRequest,
} from "@/core/request";
import router from "../router";
import Datatable from "../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../components/Sidebar.vue";
import moment from "moment";
import { mapActions } from "vuex";
import AutoLogout from "../components/AutoLogout.vue";
import Loader from "@/components/Loader.vue";
import BranchOfficesList from "../components/BranchOfficesList.vue";

import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import {
  required,
  max,
  min,
  numeric,
  alpha_num,
  regex,
} from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max", {
  ...max,
  message: "{_field_} no debe ser mayor de {length} caracteres",
});
extend("min", {
  ...min,
  message: "{_field_} no debe ser menor de {length} caracteres",
});
extend("numeric", {
  ...numeric,
  message: "{_field_} debe ser numérico",
});
extend("alpha_num", {
  ...alpha_num,
  message: "{_field_} solo debe contener letras y números",
});
extend("regex", {
  ...regex,
  message: "{_field_} no debe contener caracteres especiales",
});

let token = sessionStorage.tokenUser;
export default {
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    AutoLogout,
    Loader,
    BranchOfficesList,
    extend,
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    valid: false,
    action: 1,
    loader: true,
    sending: false,
    nums: [],
    search: "",
    objDelete: {},
    dialogDelete: false,
    objRestore: {},
    dialogRestore: false,
    encabezado: { icono: "mdi-account-multiple", texto: "Usuarios" },
    icono: {
      icon: "mdi-information-variant",
      color: "blue",
      tooltip: "Ver información",
    },
    listUsers: [],
    headers: [
      { text: "ID Usuario", value: "idUser",  align: "center" },
      { text: "Nombre completo", value: "nameUser",  align: "center", },
      { text: "Usuario", value: "username",  align: "center", },
      { text: "Correo electrónico", value: "email",  align: "center", },
      { text: "Rol", value: "role",  align: "center", },
      { text: "Fecha de registro", value: "registrationDate",  align: "center", },
      { text: "Estatus", value: "status",  align: "center", },
      { text: "Acciones", value: "actions", sortable: false,  align: "center", },
    ],
    eventS: null,
    ventana: "",
    nameRules: [(v) => !!v || "Campo requerido"],
    // ! USER DETAILS
    titleUsers: { texto: "", icono: "" },
    isEditing: true,
    userInfo: {},
    estadoCivil: [],
    genero: [
      { text: "Femenino", value: "M" },
      { text: "Masculino", value: "H" },
      { text: "No binario", value: "X" },
    ],
    roles: [],
    personalType: [],
    assignBranches: [],
    federalEntities: [],
    birthFederalEntities: [],
    municipalities: [],
    colonies: [],
    noPostal: false,
    nationality: [
      { text: "Mexicana", value: "Mexicana" },
      { text: "Otra", value: "Otro" },
    ],
    otherNationality: "",
    filesSign: [],
    dataSign: {
      file: null,
      idUser: null,
    },
    validTypePerson: false,
    requiredSign: false,
    updateInfo: false,
    modalitiesList: [],
    invalidSign: true,
    dateBirthdate: false,
    date: null,
    dateFormatted: null,
    invalidDate: false,
    activePicker: null,
    /**validaciones */
    genVal: false,
    entityVal: false,
    birthDateVal: false,
    genericCurp: "XXXX999999XXXXXX99",
  }),
  created() {
    this.listAllUsers();
    this.validBrowserTab();
    this.listAllEntities();
  },
  watch: {
    // date(val) {
    //   try {
    //     this.dateFormatted = this.formatDate(this.date);
    //     let result = moment(this.dateFormatted, "DD/MM/YYYY", true).isValid();
    //     let today = moment(new Date()).format("YYYY-MM-DD");
    //     if (result) {
    //       if (this.date < today) {
    //         this.invalidDate = false;
    //         document.getElementById("fechaNac").style = "none";
    //       } else {
    //         this.invalidDate = true;
    //         this.$utilFront.notifications(
    //           "La fecha no puede ser mayor a la fecha actual",
    //           "WARNING"
    //         );
    //         document.getElementById("fechaNac").style.color = "red";
    //       }
    //     } else {
    //       this.invalidDate = true;
    //       this.$utilFront.notifications(
    //         "Formato de fecha incorrecto",
    //         "WARNING"
    //       );
    //       document.getElementById("fechaNac").style.color = "red";
    //     }
    //   } catch (e) {}
    // },
    "userInfo.name": function(val) {
      this.userInfo.name = this.capitalize(val);
    },
    "userInfo.firstLastname": function(val) {
      this.userInfo.firstLastname = this.capitalize(val);
    },
    "userInfo.secondLastname": function(val) {
      this.userInfo.secondLastname = this.capitalize(val);
    },
    "userInfo.curp": function() {
      this.initCurpValidation();
    },
  },
  computed: {
    // computedDateFormatted() {
    //   return this.formatDate(this.date);
    // },
  },
  methods: {
    initCurpValidation() {
      this.gendervalidation();
      this.entityvalidation();
      // this.birthdatevalidation();
    },
    gendervalidation() {
      let validate = true;
      let curpgender = this.userInfo.curp;
      if (this.genericCurp == this.userInfo.curp) {
        validate = false;
      }
      if (validate) {
        switch (curpgender.charAt(10)) {
          case "H":
            this.userInfo.gender = "H";
            this.genVal = true;
            break;
          case "M":
            this.userInfo.gender = "M";
            this.genVal = true;
            break;
          case "X":
            this.userInfo.gender = "X";
            this.genVal = true;
            break;
        }
      }
    },
    entityvalidation() {
      let validate = true;
      let entityName = "";
      let entityCurp =
        this.userInfo.curp.charAt(11) + this.userInfo.curp.charAt(12);
      if (this.genericCurp == this.userInfo.curp) {
        validate = false;
      }
      if (validate) {
        for (let i in this.birthFederalEntities) {
          if (this.birthFederalEntities[i].entitykey == entityCurp) {
            entityName = this.birthFederalEntities[i].text;
          }
        }
        this.userInfo.birthFederalEntity = entityName;
        this.entityVal = true;
      }
    },
    listAllEntities() {
      FederalEntityRequest.listAllFederalEntity().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.birthFederalEntities = res.data.data.map((birthEntity) => {
            return {
              text: birthEntity.name,
              value: birthEntity.name,
              entitykey: birthEntity.federalEntityKey,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    capitalize(e) {
      if (e) {
        const strName = e;

        const arr = strName.split(" ");

        for (let i = 0; i < arr.length; i++) {
          arr[i] =
            arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
        }

        const newStrName = arr.join(" ");

        e = newStrName;

        return e;
      }
    },
    strUpperCase(event) {
      return event.toUpperCase();
    },
    changeAction(action) {
      if (action == 1) {
        this.action = action;
        this.updateInfo = false;
        this.isEditing = true;
      } else if (action == 2) {
        this.action = action;
        this.titleUsers.texto = "Informacion de usuario";
        this.titleUsers.icono = "mdi-account";
      } else if (action == 3) {
        this.action = action;
        this.isEditing = false;
        this.titleUsers.texto = "Editar usuario";
        this.titleUsers.icono = "mdi-account-edit";
      }
    },
    showAction(action) {
      return this.action == action;
    },
    // parseDate(date) {
    //   if (!date) return null;

    //   const [day, month, year] = date.split("/");
    //   return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    // },
    // formatDate(date) {
    //   if (!date) return null;

    //   const [year, month, day] = date.split("-");
    //   return `${day}/${month}/${year}`;
    // },
    ...mapActions(["validTab", "logout", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },

    ask: function(event, item) {
      event.stopPropagation();
      event.preventDefault();
      this.getItem(item);
    },
    getItem(item) {
      this.objDelete = item;
      this.dialogDelete = true;
    },
    getItemRestore(item) {
      this.objRestore = item;
      this.dialogRestore = true;
    },

    getUser(item, type) {
      let id = item.idUser;
      if (type == "edit") {
        this.$router.push({
          name: "EditarUsuario",
          params: { id: id },
        });
      } else {
        this.$router.push({
          name: "InformacionUsuario",
          params: { id: id },
        });
      }
    },
    listAllUsers() {
      this.loader = true;
      let data = {
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : null,
      };
      let allUser = UserRequest.listAllUsers(data);
      allUser
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.listUsers = res.data.data.map((user) => {
              //user.nameUser = ""+user.username+" / " + user.nameUser;
              user.registrationDate =
                user.registrationDate != null
                  ? moment(new Date(user.registrationDate)).format("DD/MM/YYYY")
                  : "--";
              return user;
            });
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(
              "Error al listar usuarios, intente nuevamente",
              "ERROR"
            );
          }
        })
        .catch((e) => {
          //console.log(e)
          this.$utilFront.notifications(
            "Ha ocurrido un error interno",
            "ERROR"
          );
        })
        .finally(() => {
          this.sending = false;
          this.loader = false;
        });
    },
    changeStatus() {
      if (!this.loader) {
        this.loader = true;
        this.sending = true;
        let data = {
          idUser: this.objDelete.idUser,
          status: this.objDelete.status,
        };

        UserRequest.deleteUser(data)
          .then((res) => {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.listUsers.forEach((element) => {
                if (element.idUser == this.objDelete.idUser) {
                  element.status = this.objDelete.status == 0 ? 1 : 0;
                }
              });
              this.$utilFront.notifications(
                "Estatus modificado correctamente",
                "SUCCESS"
              );
            } else {
              this.$utilFront.notifications(
                "Error al modificar el estatus, intente nuevamente",
                "ERROR"
              );
            }
            this.dialogDelete = false;
          })
          .catch((e) => {
            //console.log(e)
            this.$utilFront.notifications(
              "Ha ocurrido un error interno",
              "ERROR"
            );
          })
          .finally(() => {
            this.loader = false;
            this.sending = false;
          });
      }
    },

    resPassword(item) {
      if (!this.loader) {
        this.loader = true;
        let data = {
          idUser: item.idUser,
        };
        UserRequest.restorePassword(data)
          .then((res) => {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.$utilFront.notifications(
                "Contraseña actualizada correctamente",
                "SUCCESS"
              );
            } else {
              this.$utilFront.notifications(
                "Error al restablecer la contraseña, intente nuevamente",
                "ERROR"
              );
            }
            this.dialogRestore = false;
          })
          .catch((e) => {
            //console.log(e)
            this.$utilFront.notifications(
              "Ha ocurrido un error interno",
              "ERROR"
            );
          })
          .finally(() => {
            this.loader = false;
          });
      }
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAllUsers();
    },

    getUserInformation(item, method) {
    this.sending = true;
    let data = {
      idUser: item.idUser,
    };

    UserRequest.findUserById(data)
      .then((res) => {
        const objUser = res.data.data;
        const person = objUser.person;

        this.validTypePerson =
          objUser.personalType.requiresSignature == 1 ? true : false;
        this.requiredSign = objUser.sign == null ? true : false;
        this.date = moment(person.birthDate).format("YYYY-MM-DD");

        let objPerson = {
          idUser: objUser.idUser,
          idPerson: person.idPerson,
          name: person.name,
          firstLastname: person.firstLastname,
          secondLastname: person.secondLastname,
          curp: person.curp,
          rfc: objUser.rfc,
          gender: person.gender,
          nationality: person.nationality,
          birthFederalEntity: person.birthFederalEntity,
          maritalStatus: person.maritalStatus,
          idAddress: person.address.idAddress,
          street: person.address.street,
          outdoorNumber: person.address.outdoorNumber,
          interiorNumber: person.address.interiorNumber,
          postalCode: person.address.postalCode,
          federalEntity: person.address.federalEntityKey,
          municipalityEntity: person.address.municipalityKey,
          colonyKey: person.address.colonyKey,
          idContactInformation:
            person.contactInformation.idContactInformation,
          email: person.contactInformation.email,
          cellphone: person.contactInformation.phone,
          homePhone: person.contactInformation.homePhone,
          userName: objUser.username,
          role: objUser.role.idRole,
          personalType: objUser.personalType.idPersonalType,
          idHumanResource: objUser.idHumanResource,
          humanResourceKey: objUser.humanResourceKey,
          humanResourceType: objUser.humanResourceType,
          externalId: objUser.externalId,
          idBranchOffice: person.branchOffice.idBranchOffice,
          branchOfficeList: objUser.branchOfficeList,
          modalitiesList: objUser.modalitiesList,
          academicTitleList: objUser?.academicTitleList,
          idAcademicTitle: objUser?.idAcademicTitle,
          academicTitle: objUser.academicTitleList?.name,
          acronym: objUser.academicTitleList?.acronym,
          studyDegree: objUser?.studyDegree,
          professionalLicense: objUser.academicTitleList?.professionalLicense,
          sign: objUser.sign,
          status: objUser.status,
        };

        if (objPerson.nationality != "Mexicana") {
          this.otherNationality = objPerson.nationality;
          objPerson.nationality = "Otro";
        }

        if (objPerson.sign != null) this.validTypePerson = false;

        this.userInfo = objPerson;
        
        if (method == "GET_INFORMATION") this.changeAction(2);
        else if (method == "UPDATE_INFORMATION") {
          this.changeAction(3);
          this.updateInfo = true;
        }
      })
      .then(() => {
        this.listMaritalStatus();
        this.listRole();
        this.listAllPersonalType();
        this.listAllBranchOffice();
        this.findAddress(true);
        this.listAllModalities();
      })
      .finally(() => {
        this.sending = false;
      });
  },

    listMaritalStatus() {
      EnumRequest.listAllMaritalStatus({
        headers: { Authorization: token },
      }).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.estadoCivil = res.data.data.map((status) => {
            return {
              text: status.text,
              value: status.value,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listRole() {
      RoleRequest.listAllRoles().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          let statusRol = res.data.data.filter((rol) => rol.status == 1);
          this.roles = statusRol.map((role) => {
            return {
              text: role.name,
              value: role.idRole,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAllPersonalType() {
      PersonalTypeRequest.listAllPersonalType().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.personalType = res.data.data.map((entity) => {
            return {
              text: entity.name,
              value: entity.idPersonalType,
              signRequired: entity.requiresSignature,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAllBranchOffice() {
      BranchOfficeRequest.listAllBranchOffice2().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.assignBranches = res.data.data.map((entity) => {
            return {
              text: entity.name,
              value: entity.idBranchOffice,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAllModalities() {
      ModaltyRequest.allModality().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.modalitiesList = res.data.data.map((modality) => {
            return {
              text: modality.acronym + " - " + modality.name,
              value: modality.idModality,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    findAddress(nonAsign) {
      if (this.userInfo?.postalCode.length == 5) {
        let postalCode = this.userInfo.postalCode;
        this.sending = true;

        this.federalEntities = [];
        this.municipalities = [];
        this.colonies = [];

        SepomexRequest.listAllByPostalCode({ postalCode: postalCode })
          .then((res) => {
            const { data, response, message } = res.data;

            if (response) {
              this.noPostal = false;
              this.federalEntities = data
                .map((federal) => {
                  if (nonAsign != true) {
                    this.userInfo.federalEntity = federal.federalEntity;
                  }
                  return federal.federalEntity;
                })
                .filter(this.onlyUnique);

              this.municipalities = data
                .map((municipality) => {
                  if (nonAsign != true) {
                    this.userInfo.municipalityEntity =
                      municipality.municipality;
                  }
                  return municipality.municipality;
                })
                .filter(this.onlyUnique);

              this.colonies = data
                .map((colony) => {
                  if (nonAsign != true) {
                    this.userInfo.colonyKey = colony.settlement;
                  }
                  return colony.settlement;
                })
                .filter(this.onlyUnique);
            } else {
              this.noPostal = true;
              this.$utilFront.notifications(
                "Código postal no registrado, capturar manualmente.",
                "WARNING"
              );
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    validateSign(value) {
      this.invalidSign = true;
      try {
        if (this.filesSign) {
          let formats = ["image/png", "image/jpeg", "image/jpg"];
          let typeFile = this.filesSign.type;
          let isValidFormat = formats.find((format) => {
            return typeFile == format;
          });
          if (isValidFormat) {
            this.invalidSign = false;
          } else {
            this.$utilFront.notifications(
              `Formato ${typeFile} no admitido.`,
              "ERROR"
            );
            this.filesSign = undefined;
          }
        }
      } catch (error) {
        this.catchError(error);
      }
    },
    saveSignToUser() {
      if (this.filesSign != null && this.filesSign.length != 0) {
        this.getBase64(this.filesSign);
      } else {
        this.updateUser();
      }
    },
    saveSign() {
      try {
        this.sending = true;

        SignRequest.addToUser(this.dataSign)
          .then((res) => {
            let { data, status, code } = res.data;
            if (code == 200 && data == true) {
              this.$utilFront.notifications(
                "Firma registrada correctamente",
                "SUCCESS"
              );

              this.filesSign = undefined;
              this.validateSign();
            } else if (code == 401) {
              this.unauthorized();
            } else if (typeof data == "string") {
              this.$utilFront.notifications(
                "Error al registrar firma, intente nuevamente",
                "ERROR"
              );
            } else {
              this.catchError();
            }
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
    getBase64(file) {
      let reader = new FileReader();
      let fileByte = [];
      reader.readAsArrayBuffer(file);
      reader.onload = (evt) => {
        if (evt.target.readyState == FileReader.DONE) {
          let arrayBuffer = evt.target.result,
            array = new Uint8Array(arrayBuffer);
          for (let byte of array) {
            fileByte.push(byte);
          }
        }
        this.dataSign.file = fileByte;
        this.dataSign.idUser = this.$route.params.id;
        //this.saveSign();
        this.updateUser();
      };
      reader.onerror = function(error) {
        //console.log("Error: ", error);
        this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
      };
    },
    updateUser() {
      if (!this.sending) {
        this.sending = true;
        this.loader = true;
        let nan;
        let obj = this.userInfo;
        let bdEntity = "";
        let nationality = "";
        if (obj.nationality === "Otro") {
          bdEntity = "Ninguno";
          nan = this.otherNationality;
        } else {
          bdEntity = obj.birthFederalEntity;
          nationality = obj.nationality;
        }

        let updateData = {
          idUser: obj.idUser,
          username: obj.userName,
          idHumanResource: obj.idHumanResource,
          idAcademicTitle: obj.idAcademicTitle,
          humanResourceKey: obj.humanResourceKey,
          humanResourceType: obj.humanResourceType,
          externalId: obj.externalId,
          studyDegree: obj?.studyDegree,
          academicTitleList: {
            idAcademicTitle: obj?.idAcademicTitle,
            name: obj?.academicTitle,
            acronym: obj?.acronym,
            professionalLicense: obj?.professionalLicense,
          },
          sign: this.dataSign.file,
          role: {
            idRole: obj.role,
          },
          personalType: {
            idPersonalType: obj.personalType,
          },
          branchOfficeList: obj.branchOfficeList,
          modalitiesList: obj.modalitiesList,
          rfc: obj.rfc, // <- AGREGAR ESTA LÍNEA
          person: {
            idPerson: obj.idPerson,
            name: obj.name,
            firstLastname: obj.firstLastname,
            secondLastname: obj.secondLastname,
            curp: obj.curp,
            gender: obj.gender,
            birthDate: moment(this.date).startOf("day"),
            birthFederalEntity: bdEntity,
            maritalStatus: obj.maritalStatus,
            status: obj.status,
            contactInformation: {
              idContactInformation: obj.idContactInformation,
              email: obj.email,
              phone: obj.cellphone,
              homePhone: obj.homePhone,
            },
            branchOffice: {
              idBranchOffice: obj.idBranchOffice,
            },
            address: {
              idAddress: obj.idAddress,
              interiorNumber: obj.interiorNumber,
              outdoorNumber: obj.outdoorNumber,
              postalCode: obj.postalCode,
              street: obj.street,
              federalEntityKey: obj.federalEntity,
              municipalityKey: obj.municipalityEntity,
              colonyKey: obj.colonyKey,
            },
            nationality: nationality,
            indigenousLanguage: 0,
          },
        };
        
        try {
          UserRequest.updateUser(updateData)
            .then((res) => {
              const { data, code, status } = res.data;
              if (code == 200 && status == "OK") {
                this.$utilFront.notifications(data, "SUCCESS");
                this.userInfo = {};
                this.changeAction(1);
              } else if (code == 401) {
                this.unauthorized();
              } else {
                this.$utilFront.notifications(data, "ERROR");
              }
            })
            .finally(() => {
              this.sending = false;
              this.loader = false;
              this.listAllUsers();
            });
        } catch (error) {
          this.sending = false;
          this.loader = false;
        }
      }
    }
  },
};
</script>
<style scoped>
.btn-grad {
  background-image: linear-gradient(
    to right,
    #76b852 0%,
    #8dc26f 51%,
    #76b852 100%
  );
}
.btn-grad {
  margin: 10px;
  padding: 15px 45px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  box-shadow: 0 0 20px #eee;
  border-radius: 10px;
  display: block;
}

.btn-grad:hover {
  background-position: right center; /* change the direction of the change here */
  color: #fff;
  text-decoration: none;
}
</style>
